<template>
  <div class="container-fluid mt-4" style="max-width: 1000px; font-weight: bold">
    <b-card>
      <span style="float:left"><h3>Create A Support Ticket</h3></span>
      <span style="float:right"><b-button variant="success" size="md" :to="{ name: 'support_ticket_list' }"><span style="color:white">Back To List</span></b-button></span>
      <br/><br/><hr/>

      <form @submit.prevent="saveSupportTicket">

        <table cellpadding="10" cellspacing="10" width="100%" style="font-size: 18px">
          <tr v-if="user.role === 'admin'">
            <td align="left" valign="top">
              <h5>Account</h5>
              <b-form-select v-model="selected_tenant_id" :options="user.tenant_options" />
            </td>
            <td align="left" valign="top" colspan="2">
              <h5>Internal Notes</h5>
              <b-form-textarea style="field-sizing: content" v-model="model.internal_notes" />
            </td>
          </tr>
          <tr v-if="user.role === 'admin'">
            <td align="left" valign="top">
              <h5>Created By</h5>
              <span>
                  <b-form-select v-model="model.username" :options="user_options" />
                </span>
            </td>
            <td align="left" valign="top">
              <h5>Assigned To</h5>
              <span v-if="user.role === 'admin'">
                  <b-form-select v-model="model.assigned_to" :options="assignedOptions" />
                </span>
            </td>
          </tr>
          <tr>
            <td align="left" valign="top">
              <h5>Account</h5>
              <span style="margin-top:4px; font-size: 18px">{{getOptionText(user.tenant_options, selected_tenant_id)}}</span>
            </td>
            <td align="left" valign="top" colspan="2">
              <h5>Additional Contacts (comma separated emails)</h5>
              <b-form-input type="text" v-model="model.additional_contacts" />
            </td>
          </tr>
          <tr>
            <td align="left" valign="top">
              <h5>Feature</h5>
              <b-form-select style="width: 250px" v-model="model.category" :options="categoryOptions" />
            </td>
            <td align="left" valign="top">
              <h5>Priority</h5>
              <b-form-select style="width: 250px" v-model="model.priority" :options="priorityOptions" />
            </td>
            <td>&nbsp;</td>
          </tr>
          <tr>
            <td align="left" valign="top" colspan="3">
              <h5>Your Role (please describe your position for context)</h5>
              <b-form-input type="text" v-model="model.creator_role" />
            </td>
          </tr>
          <tr>
            <td align="left" valign="top" colspan="3">
              <h5>Subject</h5>
              <b-form-input type="text" v-model="model.subject" />
            </td>
          </tr>
          <tr>
            <td align="left" valign="top" colspan="3">
              <h5>Description (text only, use attachments for images, etc)</h5>
              <b-form-textarea style="field-sizing: content" v-model="model.description" />
            </td>
          </tr>
          <tr>
            <td align="left" valign="top" colspan="3">
              <h5>Attachments</h5>
              <input
                ref="ticketAttachmentInput"
                type="file"
                multiple
                style="display: none"
                @change="handleFileUpload"
              />
              <div class="d-flex align-items-center flex-wrap gap-2">
                <b-button size="sm" variant="primary" @click="$refs.ticketAttachmentInput.click()" :disabled="isSubmitting">
                  Add Attachment(s)
                </b-button>
                <b-button
                  v-if="attachmentItems.length > 0"
                  size="sm"
                  variant="outline-danger"
                  @click="clearAttachmentItems"
                  :disabled="isSubmitting"
                >
                  Clear All
                </b-button>
              </div>
              <div v-if="attachmentItems.length === 0" class="text-muted small mt-2">
                No attachments selected yet.
              </div>
              <div v-else class="attachment-grid mt-3">
                <div
                  v-for="item in attachmentItems"
                  :key="item.id"
                  class="attachment-item queued-attachment"
                  :class="'attachment-state-' + item.status"
                >
                  <button
                    v-if="item.status === 'queued' || item.status === 'failed'"
                    type="button"
                    class="attachment-remove"
                    @click="removeAttachmentItem(item.id)"
                  >
                    &times;
                  </button>
                  <img
                    v-if="item.previewUrl"
                    :src="item.previewUrl"
                    class="attachment-thumbnail"
                    :alt="item.name"
                  />
                  <div v-else class="attachment-file">
                    <span style="font-size: 1.4rem;">&#128196;</span>
                    <span class="attachment-filename">{{ item.name }}</span>
                  </div>
                  <div v-if="item.status === 'uploading' || item.status === 'failed'" class="attachment-meta">
                    <div class="attachment-status">
                      <span v-if="item.status === 'uploading'">Uploading {{ item.progress }}%</span>
                      <span v-else>Upload failed</span>
                    </div>
                    <b-progress
                      v-if="item.status === 'uploading'"
                      :value="item.progress"
                      :max="100"
                      height="6px"
                      class="mt-2"
                    />
                    <div v-if="item.error" class="attachment-error">{{ item.error }}</div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </table>
        <br/><br/>
        <div>
          <b-btn type="submit" variant="success" :disabled="isSubmitting">Create</b-btn>
          &nbsp;&nbsp;
          <b-button :to="{ name: 'support_ticket_list' }">
            Cancel
          </b-button>
        </div>
      </form>
    </b-card>
  </div>
</template>

<script>
import {
  create_support_ticket,
  get_primary_users,
  presign_support_ticket_attachment,
  finalize_support_ticket_attachment
} from '../networking/apis'
import {mapState} from "vuex";

export default {
  name: 'support_ticket_create',
  components: {  },
  data () {
    return {
      selected_tenant_id: null,
      user_options: [],
      assignedOptions: [
        { value: null, text: 'Unassigned' },
        { value: 'ben@initekconsulting.com', text: 'Ben ODay' },
        { value: 'jen@initekconsulting.com', text: 'Jen Mayer' },
        { value: 'chaz@initekconsulting.com', text: 'Chaz Watson' },
        { value: 'kai@initekconsulting.com', text: 'Kai Klein' },
        { value: 'evan@initekconsulting.com', text: 'Evan Anderson' },
      ],
      model: { 'category': 'general', 'priority': 'question'},
      attachmentItems: [],
      isSubmitting: false,
      categoryOptions: [
        {value: 'general', text: 'General'},
        {value: 'actuals', text: 'Actuals'},
        {value: 'alerts', text: 'Alerts'},
        {value: 'maps', text: 'Map Views'},
        {value: 'reports', text: 'View & Reports'},
        {value: 'vsm', text: 'Vehicle Status Manager'},
        {value: 'data', text: 'Data Services'},
        {value: 'fleet-assistant', text: 'Fleet Assistant'},
      ],
      priorityOptions: [
        {value: 'question', text: 'Question/Request'},
        {value: 'minor', text: 'Minor Bug'},
        {value: 'urgent', text: 'Major Bug / System Issue'},
        {value: 'enhancement', text: 'Enhancement Request'},
        {value: 'feature', text: 'New Feature Request'},
      ],
    }
  },
  async created () {
    this.selected_tenant_id = this.user.tenant
    if (this.user.role == 'admin')
      await this.load_users()
  },
  beforeDestroy() {
    this.revokeAttachmentPreviews()
  },
  methods: {
    getOptionText(options, value) {
      const option = options.find(opt => opt.value === value)
      return option ? option.text : value
    },
    async load_users() {
      const {value: {data = []}} = await get_primary_users(this.selected_tenant_id)
      if (data.results.length > 0) {
        this.user_options = data.results.map(item => ({
          value: item['username'],
          text: item['first_name'] ? item['first_name'] + ' ' + item['last_name'] + ' - ' + item['username'] : item['username']
        }));
        this.user_options.concat(this.assignedOptions)
      } else {
        this.user_options = this.assignedOptions
      }
    },
    async saveSupportTicket () {
      try{
        this.isSubmitting = true
        this.$emit('showAlert', "waiting for response...", 'info')
        const {value: {data = []}} = await create_support_ticket(this.selected_tenant_id,this.model)
        this.model.id = data.ticket_id

        const failedAttachmentCount = await this.saveAttachments()

        if (failedAttachmentCount > 0) {
          this.$emit('showAlert', `Support ticket created, but ${failedAttachmentCount} attachment(s) failed to upload. You can retry from the ticket details screen.`, 'warning', 7000)
          this.$router.push({ name: 'support_ticket_details', query: { tenant_id: this.selected_tenant_id, id: this.model.id } })
          return
        }

        this.$emit('showAlert', data.message || 'Success!', 'success', 1500)
        this.$router.push({name:'support_ticket_list'})
      } catch(e) {
        this.$emit('showAlert', 'error creating ticket, contact support if needed', 'danger', 5000)
      } finally {
        this.isSubmitting = false
      }
    },
    handleFileUpload(event) {
      const files = event && event.target && event.target.files ? Array.from(event.target.files) : []
      if (event && event.target) {
        event.target.value = null
      }
      if (!files.length) return

      const existingKeys = new Set(this.attachmentItems.map(item => `${item.name}:${item.size}`))
      const newItems = files
        .filter(file => !existingKeys.has(`${file.name}:${file.size}`))
        .map((file, index) => this.createAttachmentItem(file, index))
      this.attachmentItems = [...this.attachmentItems, ...newItems]
    },
    createAttachmentItem(file, index) {
      return {
        id: `${Date.now()}-${Math.random().toString(16).slice(2)}-${index}`,
        file,
        name: file.name,
        size: file.size,
        status: 'queued',
        progress: 0,
        error: null,
        previewUrl: file.type && file.type.startsWith('image/') ? URL.createObjectURL(file) : null,
      }
    },
    removeAttachmentItem(itemId) {
      const item = this.attachmentItems.find(candidate => candidate.id === itemId)
      if (item && item.previewUrl) {
        URL.revokeObjectURL(item.previewUrl)
      }
      this.attachmentItems = this.attachmentItems.filter(candidate => candidate.id !== itemId)
    },
    clearAttachmentItems() {
      this.revokeAttachmentPreviews()
      this.attachmentItems = []
    },
    revokeAttachmentPreviews() {
      this.attachmentItems.forEach(item => {
        if (item.previewUrl) {
          URL.revokeObjectURL(item.previewUrl)
        }
      })
    },
    async saveAttachments() {
      const queuedItems = this.attachmentItems.filter(item => item.status === 'queued' || item.status === 'failed')
      if (!queuedItems.length) {
        return 0
      }

      this.$emit('showAlert', "Uploading support ticket attachments...", 'info')

      const CONCURRENCY = 3
      let index = 0
      const worker = async () => {
        while (index < queuedItems.length) {
          const item = queuedItems[index++]
          await this.uploadAttachmentItem(item)
        }
      }
      await Promise.all(
        Array.from({ length: Math.min(CONCURRENCY, queuedItems.length) }, () => worker())
      )

      return this.attachmentItems.filter(item => item.status === 'failed').length
    },
    async uploadAttachmentItem(item) {
      const attachmentIndex = this.attachmentItems.findIndex(candidate => candidate.id === item.id)
      if (attachmentIndex === -1) return

      this.$set(this.attachmentItems, attachmentIndex, {
        ...this.attachmentItems[attachmentIndex],
        status: 'uploading',
        progress: 0,
        error: null,
      })

      try {
        const file = item.file
        const filename = file.name || 'attachment'
        const contentType = file.type || 'application/octet-stream'

        const presignResp = await presign_support_ticket_attachment(this.selected_tenant_id, {
          filename,
          content_type: contentType,
          file_size: file.size || 0,
        })
        const presignData = presignResp && presignResp.value && presignResp.value.data
          ? (presignResp.value.data.data || presignResp.value.data)
          : {}
        const upload = presignData.upload || {}
        const s3Url = presignData.s3_url

        const uploadForm = new FormData()
        Object.entries(upload.fields || {}).forEach(([k, v]) => uploadForm.append(k, v))
        uploadForm.append('file', file)

        await this.uploadToS3WithProgress(upload.url, uploadForm, (pct) => {
          this.updateAttachmentItem(item.id, { progress: pct })
        })

        await finalize_support_ticket_attachment(this.selected_tenant_id, {
          ticket_id: this.model.id,
          attachment_url: s3Url,
        })

        this.updateAttachmentItem(item.id, {
          status: 'uploaded',
          progress: 100,
          error: null,
        })
      } catch (err) {
        const msg = err && err.response && err.response.data && err.response.data.error
          ? err.response.data.error
          : (err && err.message ? err.message : 'Upload failed')
        console.warn('[Support Ticket] Presign upload error', err)
        this.updateAttachmentItem(item.id, {
          status: 'failed',
          progress: 0,
          error: msg,
        })
      }
    },

    uploadToS3WithProgress(url, formData, onProgress) {
      return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest()
        xhr.open('POST', url, true)
        xhr.onload = () => {
          if (xhr.status >= 200 && xhr.status < 300) {
            resolve()
          } else {
            let detail = `S3 upload failed (HTTP ${xhr.status})`
            try {
              const xml = xhr.responseText || ''
              const codeMatch = xml.match(/<Code>([^<]+)<\/Code>/)
              const msgMatch = xml.match(/<Message>([^<]+)<\/Message>/)
              if (codeMatch || msgMatch) {
                detail = [codeMatch && codeMatch[1], msgMatch && msgMatch[1]].filter(Boolean).join(': ')
              }
            } catch (_) { /* ignore parse errors */ }
            reject(new Error(detail))
          }
        }
        xhr.onerror = () => reject(new Error('S3 upload failed (network error)'))
        xhr.upload.onprogress = (event) => {
          if (!event.lengthComputable || typeof onProgress !== 'function') return
          const pct = Math.max(0, Math.min(100, Math.round((event.loaded / event.total) * 100)))
          onProgress(pct)
        }
        xhr.send(formData)
      })
    },
    updateAttachmentItem(itemId, patch) {
      const index = this.attachmentItems.findIndex(item => item.id === itemId)
      if (index === -1) return
      this.$set(this.attachmentItems, index, {
        ...this.attachmentItems[index],
        ...patch,
      })
    },
  },
  computed:{
    ...mapState({
      user: state => state.profile.user
    }),
  },
  watch: {
    user: {
      deep: true,
      handler() {
        this.load_users()
      }
    },
    selected_tenant_id() {
      if (this.user.role == 'admin')
        this.load_users()
    }
  }
}
</script>

<style scoped>
a { color: white}

.gap-2 {
  gap: 0.5rem;
}

.attachment-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.queued-attachment {
  position: relative;
  width: 130px;
  padding: 8px;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  background: #fff;
  overflow: hidden;
}

.attachment-thumbnail {
  width: 100%;
  height: 80px;
  object-fit: contain;
  border-radius: 4px;
}

.attachment-file {
  height: 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4px;
}

.attachment-filename,
.attachment-name {
  font-size: 0.7rem;
  word-break: break-word;
  text-align: center;
}

.attachment-meta {
  margin-top: 6px;
}

.attachment-name {
  font-size: 0.7rem;
  color: #343a40;
}

.attachment-status {
  font-size: 0.65rem;
  color: #6c757d;
  margin-top: 2px;
}

.attachment-error {
  font-size: 0.65rem;
  color: #c82333;
  margin-top: 2px;
}

.attachment-remove {
  position: absolute;
  top: 4px;
  right: 4px;
  border: none;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  border-radius: 999px;
  width: 20px;
  height: 20px;
  line-height: 1;
  font-size: 0.8rem;
  cursor: pointer;
}

.attachment-state-uploading {
  border-color: #0d6efd;
}

.attachment-state-uploaded {
  border-color: #28a745;
}

.attachment-state-failed {
  border-color: #dc3545;
}
</style>
